import './index.css';
import { Link } from 'react-router-dom';

const LuxUnboundedComponent = () => {
  return (
    <div className="luxunlock-wrapper">
      <div className="luxunlock-side-image left">
        <img
          src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400"
          alt="Scenic landscape 1"
          className="luxunlock-image"
        />
      </div>
      <div className="luxunlock-content">
        <h1 className="luxunlock-heading">ABOUT LUXEUNBOUNDED</h1>
        <p className="luxunlock-description">
          Unlock and gain privileged access to the most beautiful, unique private
          homes for exclusive & luxurious holidays with family & friends!
        </p>
        <Link to="/our-story">
          <button className="luxunlock-button">KNOW MORE</button>
        </Link>
        <div className="luxunlock-center-image">
          <img
            src="https://images.unsplash.com/photo-1513694203232-719a280e022f?w=400"
            alt="Luxury interior"
            className="luxunlock-image"
            style={{ height: '350px'}}
          />
        </div>
      </div>

      <div className="luxunlock-side-image right">
        <img
          src="https://images.unsplash.com/photo-1476673160081-cf065607f449?w=400"
          alt="Scenic landscape 2"
          className="luxunlock-image"
        />
      </div>
    </div>
  );
};

export default LuxUnboundedComponent;
